import BroadcastPlayer from "./components/BroadcastPlayer.jsx";
import SeriesPlayer from "./components/SeriesPlayer.jsx";
import MediaPlayer from "./components/MediaPlayer.jsx";
import './App.css';
import './FeaturedAudioPlayer.css';
import ImaPlayer from "./components/ImaPlayer.jsx";
import { BrandProvider } from "./contexts/BrandContext.jsx";

function App() {
    // Check if we're in development mode (localhost)
    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    // In development, check for URL parameter to override player type
    // Usage: http://localhost:3000?player=series or http://localhost:3000?player=broadcast
    const urlParams = new URLSearchParams(window.location.search);
    const playerParam = urlParams.get('player');
    
    let playerType; // 'broadcast', 'series', or 'ima'

    if (isDevelopment && playerParam) {
        // Use URL parameter in development
        playerType = playerParam;
        console.log(`🔧 Development override: Using ${playerType} player`);
    } else {
        // Production logic: check for seriesJSON data
        playerType = (window.broadcastPlayerData && window.broadcastPlayerData.seriesJSON) ? 'series' : 'broadcast';
    }

    const getPlayerName = () => {
        if (playerType === 'series') return 'Series';
        if (playerType === 'media') return 'Media Player';
        if (playerType === 'ima') return 'IMA Player';
        return 'Broadcast';
    };

    return (
        <BrandProvider>
            <div id="broadcast-player-plugin">
                {isDevelopment && (
                    <div style={{
                        position: 'fixed', 
                        top: '10px', 
                        right: '195px', 
                        zIndex: 9999, 
                        background: '#333', 
                        color: '#fff', 
                        padding: '10px', 
                        borderRadius: '5px',
                        fontSize: '12px'
                    }}>
                        <strong>Dev Mode:</strong> {getPlayerName()} Player
                        <br />
                        <a href="?player=broadcast" style={{color: '#4CAF50', marginRight: '10px'}}>Broadcast</a>
                        <a href="?player=series" style={{color: '#2196F3', marginRight: '10px'}}>Series</a>
                        <a href="?player=media" style={{color: '#E91E63', marginRight: '10px'}}>Media</a>
                        <a href="?player=ima" style={{color: '#FF9800'}}>ImaPlayer</a>
                    </div>
                )}
                {playerType === 'broadcast' && <BroadcastPlayer />}
                {playerType === 'series' && <SeriesPlayer prerollAdEnabled={false} postrollAdEnabled={true} />}
                {playerType === 'media' && <MediaPlayer prerollAdEnabled={false} postrollAdEnabled={false} />}
                {playerType === 'ima' && <ImaPlayer />}
            </div>
        </BrandProvider>
    );
}

export default App;
